<template>
  <div id="about_nav">
    <div class="nav-top">
      <div class="top-box">
        <h3>{{name}}</h3>
        <p>{{en_name?en_name:'infomation'}}</p>
      </div>
    </div>
    <div class="nav-box">
      <div class="nav-bottom">
        <div class="seat-box">
          <h3>
            您的位置：{{breadOne?breadOne:''}}
            <span
              v-if="navList && navList.length > 0"
            >{{'>'+currentChannel.channel_title}}</span>
          </h3>
          <div :class="{'border-box':classShow, 'animated': classHide, 'fadeInUpBig': classHide}"></div>
        </div>
        <ul v-if="navList && navList.length > 0">
          <li
            v-for="(item,index) in navList"
            :key="index"
            @click="getStyle(item)"
            :class="{active:(liStatus==item.id || (!liStatus && index == 0))}"
          >{{item.channel_title}}</li>
        </ul>
        <div style="margin:0 auto;" v-else>
          <h2 style="text-align:center;height:200px;line-height:200px">信息正在更新中~</h2>
        </div>
      </div>
    </div>
    <div class="nav-content" v-if="navList && navList.length > 0">
      <new-list1
        :chid="currentChannel.id"
        v-if="currentChannel.cat_type == 1 && currentChannel.template == 2"
      ></new-list1>
      <new-list2
        :chid="currentChannel.id"
        v-else-if="currentChannel.cat_type == 1 && currentChannel.template == 1"
      ></new-list2>
      <page-info :chid="currentChannel.id" v-else-if="currentChannel.cat_type == 2"></page-info>
      <new-list1
        :chid="currentChannel.id"
        :type="currentChannel.cat_type"
        v-else-if="currentChannel.cat_type == 3 && currentChannel.template == 2"
      ></new-list1>
      <new-list2
        :chid="currentChannel.id"
        :type="currentChannel.cat_type"
        v-else-if="currentChannel.cat_type == 3 && currentChannel.template == 1"
      ></new-list2>
      <!-- <project-list :chid="currentChannel.id" v-else-if="currentChannel.cat_type == 3"></project-list> -->
      <!-- <partner-info v-else-if="currentChannel.cat_type == 5 && currentChannel.template == 3"></partner-info> -->
      <volunteer
        :chid="currentChannel.id"
        v-else-if="currentChannel.cat_type == 5 && currentChannel.template == 4"
      ></volunteer>
      <branch
        :chid="currentChannel.id"
        v-else-if="currentChannel.cat_type == 5 && currentChannel.template == 6"
      ></branch>
      <council
        :chid="currentChannel.id"
        v-else-if="currentChannel.cat_type == 5 && currentChannel.template == 2"
      ></council>
      <photos :chid="currentChannel.id" v-else-if="currentChannel.cat_type == 6"></photos>
      <new-list1
        :chid="currentChannel.id"
        v-else-if="currentChannel.cat_type == 7 && currentChannel.template == 2"
      ></new-list1>
      <new-list2
        :chid="currentChannel.id"
        v-else-if="currentChannel.cat_type == 7 && currentChannel.template == 1"
      ></new-list2>
    </div>
  </div>
</template>
<script>
import newList1 from "./public_news"; //新闻图文列表
import newList2 from "./public_list"; //新闻普通列表
import pageInfo from "./public_intd"; //单页
import projectList from "./public_project"; //项目列表
import partnerInfo from "./public_partner"; //合作伙伴
import volunteer from "../Volunteer/volunteer_index"; //成为志愿者
import branch from "../Branch/branch_index"; //分会管理
// import applyInfo from "../Apply/apply_index";//在线申请
import council from "./public_council"; //理事会

import photos from "./photos"; //图集

export default {
  components: {
    newList1,
    newList2,
    pageInfo,
    projectList,
    partnerInfo,
    volunteer,
    branch,
    // applyInfo,
    council,
    photos
  },
  data() {
    return {
      classShow: true,
      classHide: false,
      enName: "infomation", //一级导航英文名
      // navShow:1,
      breadOne: null, //当前面包屑导航

      name: "", //导航标题
      en_name: "", //导航副标题

      currentChannel: {}, //存放点击的二级导航id

      navList: [],
      liStatus: null
    };
  },
  watch: {
    $route: {
      handler(val) {
        // this.getDatachild();
        this.breadOne = sessionStorage.getItem("breadOne");
        if (this.$route.query.tabid) {
          this.liStatus = this.$route.query.tabid;
        } else {
          this.liStatus = null;
        }

        if (this.$route.query.cid > 0) {
          let res;
          res = this.channelList.find(item => {
            return item.id == this.$route.query.cid;
          });

          this.navList = res.children;
          this.name = res.channel_title;
          this.en_name = res.channel_title_en;

          let info = {};
          if (this.$route.query.tabid) {
            for (const key in res.children) {
              if (res.children[key].id == this.$route.query.tabid) {
                info = res.children[key];
              }
            }

            this.currentChannel = info;
          } else {
            this.currentChannel = res.children[0];
          }
        }
      }
    },
    channelList: {
      handler(val) {
        if (val && val.length > 0) {
          let res;
          res = val.find(item => {
            return item.id == this.$route.query.cid;
          });
          this.navList = res.children;
          this.name = res.channel_title;
          this.en_name = res.channel_title_en;
          let info = {};
          if (this.$route.query.tabid) {
            for (const key in res.children) {
              if (res.children[key].id == this.$route.query.tabid) {
                info = res.children[key];
              }
            }
            this.currentChannel = info;
          } else {
            this.currentChannel = res.children[0];
          }
        }
      },
      immediate: true
    }
  },
  computed: {
    channelList() {
      let info = this.$store.state.web_channel;
      return info;
    }
  },

  methods: {
    getStyle(item) {
      //切换二级导航
      if (item.cat_type == 4) {
        window.open(item.channel_url);
      } else {
        this.currentChannel = item;
        this.$router.push({
          path: "/pubIndex",
          query: { cid: this.$route.query.cid, tabid: item.id }
        });
        this.liStatus = item.id;
      }
    },
    getDatachild() {
      //根据一级id获取二级导航

      this.$db
        .post(this.$db.config.getChildByChidUrl, { id: this.$route.query.cid })
        .then(res => {
          if (res.code == 200 && res.data && res.data.length > 0) {
            this.navList = res.data;
            let info = {};
            if (this.$route.query.tabid) {
              for (const key in res.data) {
                if (res.data[key].id == this.$route.query.tabid) {
                  info = res.data[key];
                }
              }

              this.currentChannel = info;
            } else {
              this.currentChannel = res.data[0];
            }
          } else {
            this.navList = [];
          }
        });
    }
  },

  created() {
    // this.getDatachild();
    if (this.$route.query.tabid) {
      //
      this.liStatus = this.$route.query.tabid;
    }
  }
};
</script>
<style lang="scss" scoped>
#about_nav {
  width: 100%;
}
.nav-top {
  width: 100%;
  height: 300px;
  background: url(../../assets/images/nav_bg.png) no-repeat;
  background-size: 100% 100%;
  .top-box {
    width: 1300px;
    margin: 0 auto;
    padding-top: 118px;
    > h3 {
      font-size: 36px;
      color: #333333;
      font-weight: normal;
    }
    > p {
      font-size: 26px;
      font-weight: normal;
      color: #999999;
    }
  }
}
.nav-box {
  width: 1300px;
  margin: 0 auto;
  // margin-bottom: 86px;
  .nav-bottom {
    width: 100%;
    .seat-box {
      > h3 {
        font-size: 14px;
        color: #999;
        text-align: right;
        font-weight: normal;
        padding: 28px 0 17px;
        > span {
          color: #333333;
        }
      }
      .border-box {
        width: 1300px;
        height: 1px;
        border: 1px solid #c30d23;
        border-bottom: 3px solid #c30d23;
      }
    }
    > ul {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      > li {
        list-style: none;
        padding: 15px 25px;
        font-size: 18px;
        color: #000000;
        cursor: pointer;
        &.active {
          // background-color: #fff;
          background-color: #c30d23;
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Public/public_nav.vue